module.exports = __webpack_public_path__ + "static/media/italiano_scuola.7a5b5ee4.png";